import { instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import { CreateExpenseBody } from "./createExpense.types";

export const requestCreateExpense = async (
  body: CreateExpenseBody
): Promise<void> => {
  return await instance.post(ApiRoutesInternalBank.Expenses, body);
};
